import { ONLINEHOST, QAHOST } from '../config'
import { genUpToken } from "@/utils/CryptoJS";
import { qspost } from "@/plugins/axios";

const requestUrl = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST
/**
 * 获取Token
 */
export const getToken = () => {
  let token = window.localStorage.getItem('token')
  return { token: token ? JSON.parse(token) : '' };
}

/*
* 百度编辑器配置
* */
export const bdEditConfig = () => {
  return {
    // 编辑器不自动被内容撑高
    autoHeightEnabled: false,
    // 初始容器高度
    initialFrameHeight: 320,
    // 初始容器宽度
    initialFrameWidth: '100%',
    // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
    // serverUrl: requestUrl + '/editor/controller.php',
    serverUrl: requestUrl + '/editor/controller.php',
    // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
    UEDITOR_HOME_URL: '/UEditor/'
  }
}


export const getYear = () => {
  let now = new Date()
  return now.getFullYear()
}
export const getYears = (start = 2020) => {
  let years = []
  let date = new Date();
  let fullYear = date.getFullYear();
  for (let year = fullYear; year > start; year--) {
    years.push({
      year: year
    })
  }
  return years
}

/*
* 类型
* */
export const powerTypes = (val) => {
  switch (val) {
    case 1:
      return '超管'
    case 2:
      return '超管子账号'
    case 3:
      return '总负责人'
    case 4:
      return '总负责人子管理'
    case 5:
      return '社区'
    case 6:
      return '志愿者队长'
    case 7:
      return '财务'
    case 8:
      return '志愿者'
  }
}


/*
* 性别类型
* */
export const sex = [
  { value: 0, label: '全部' },
  { value: 1, label: '男' },
  { value: 2, label: '女' },
]

export const health = [
  { value: 0, label: '全部' },
  { value: 1, label: '健康' },
  { value: 2, label: '卧床' },
  { value: 3, label: '行动不便' },
]




/*
* 户口性质
* */
export const nature = [
  { value: 0, label: '全部' },
  { value: 1, label: '农业户口' },
  { value: 2, label: '非农业户口' },
]

/*
* 与户主关系
* */
export const relation = [
  { value: 0, label: '全部' },
  { value: 1, label: '本人' },
  { value: 2, label: '夫妻' },
  { value: 3, label: '父母' },
  { value: 4, label: '儿媳' },
  { value: 5, label: '女婿' },
  { value: 6, label: '孙子、孙女' },
  { value: 7, label: '兄妹、姐弟' },
  { value: 8, label: '其他亲戚' },
  { value: 9, label: '租户' },
  { value: 10, label: '其他' },
]


/*
* 提醒类型
* */
export const tipsList = [
  { value: 0, label: '全部' },
  { value: 1, label: '生日' },
  { value: 2, label: '退休' },
  { value: 3, label: '新生儿' },
  { value: 4, label: '入托' },
  { value: 5, label: '入学' },
]


/*
* 民族
* */
export const nation = [
  { value: 0, label: "全部" },
  { value: 1, label: "汉族" },
  { value: 2, label: "满族" },
  { value: 3, label: "蒙古族" },
  { value: 4, label: "回族" },
  { value: 5, label: "藏族" },
  { value: 6, label: "维吾尔族" },
  { value: 7, label: "苗族" },
  { value: 8, label: "彝族" },
  { value: 9, label: "壮族" },
  { value: 10, label: "布依族" },
  { value: 11, label: "侗族" },
  { value: 12, label: "瑶族" },
  { value: 13, label: "白族" },
  { value: 14, label: "土家族" },
  { value: 15, label: "哈尼族" },
  { value: 16, label: "哈萨克族" },
  { value: 17, label: "傣族" },
  { value: 18, label: "黎族" },
  { value: 19, label: "傈僳族" },
  { value: 20, label: "佤族" },
  { value: 21, label: "畲族" },
  { value: 22, label: "高山族" },
  { value: 23, label: "拉祜族" },
  { value: 24, label: "水族" },
  { value: 25, label: "东乡族" },
  { value: 26, label: "纳西族" },
  { value: 27, label: "景颇族" },
  { value: 28, label: "柯尔克孜族" },
  { value: 29, label: "土族" },
  { value: 30, label: "达斡尔族" },
  { value: 31, label: "仫佬族" },
  { value: 32, label: "羌族" },
  { value: 33, label: "布朗族" },
  { value: 34, label: "撒拉族" },
  { value: 35, label: "毛南族" },
  { value: 36, label: "仡佬族" },
  { value: 37, label: "锡伯族" },
  { value: 38, label: "阿昌族" },
  { value: 39, label: "普米族" },
  { value: 40, label: "朝鲜族" },
  { value: 41, label: "塔吉克族" },
  { value: 42, label: "怒族" },
  { value: 43, label: "乌孜别克族" },
  { value: 44, label: "俄罗斯族" },
  { value: 45, label: "鄂温克族" },
  { value: 46, label: "德昂族" },
  { value: 47, label: "保安族" },
  { value: 48, label: "裕固族" },
  { value: 49, label: "京族" },
  { value: 50, label: "塔塔尔族" },
  { value: 51, label: "独龙族" },
  { value: 52, label: "鄂伦春族" },
  { value: 53, label: "赫哲族" },
  { value: 54, label: "门巴族" },
  { value: 55, label: "珞巴族" },
  { value: 56, label: "基诺族" }
]

/*
* 居住状态关系
* */
export const live = [
  { value: 0, label: '全部' },
  { value: 1, label: '正常' },
  { value: 2, label: '搬离' },
  { value: 3, label: '离世' },
]

/*
* 房屋性质
* */
export const housingNature = [
  { value: 0, label: '全部' },
  { value: 1, label: '集资房' },
  { value: 2, label: '商品房' },
  { value: 3, label: '承租房' },
  { value: 4, label: '房改房' },
  { value: 5, label: '其他' },
]

/*
* 居住情况
* */
export const liveSituation = [
  { value: 0, label: '全部' },
  { value: 1, label: '自住' },
  { value: 2, label: '出租' },
  { value: 3, label: '未住' },
]

/*
* 综改调查
* */
export const reform = [
  { value: 0, label: '全部' },
  { value: 1, label: '待沟通' },
  { value: 2, label: '不同意综改' },
  { value: 3, label: '同意综改' },

]

/*
* 物业合同
* */
export const contract = [
  { value: 0, label: '全部' },
  { value: 1, label: '待沟通' },
  { value: 2, label: '不同意' },
  { value: 3, label: '已签署' }
]

/*
* 缴费年度
* */
export const year = [
  { value: 2021, label: '2021年' },
  { value: 2022, label: '2022年' },
  { value: 2023, label: '2023年' },
  { value: 2024, label: '2024年' },
  { value: 2025, label: '2025年' },
  { value: 2026, label: '2026年' },
  { value: 2027, label: '2027年' },
  { value: 2028, label: '2028年' },
  { value: 2029, label: '2029年' },
  { value: 2030, label: '2030年' },
]

/*
* 费用
* */
export const cost = [
  { value: 0, label: '全部' },
  { value: 1, label: '物业费' },
  { value: 2, label: '保安费' },
  { value: 3, label: '卫生费' },
  { value: 4, label: '停车管理费' },
  { value: 5, label: '垃圾管理费' },
  { value: 6, label: '其他费用' }
]

/*
* 调查结果
* */
export const result = [
  { value: 0, label: '全部' },
  { value: 1, label: '待沟通' },
  { value: 2, label: '同意' },
  { value: 3, label: '拒绝' }
]



/*
* 服务类型
* */
// export const serviceList = [
//   {value: 0, label: '全部'},
//   {value: 1, label: '搬'},
//   {value: 2, label: '扫'},
//   {value: 3, label: '换'}
// ]

export const serviceList = () => {
  let arr = [
    { value: 0, label: '全部' },
    { value: 1, label: '搬' },
    { value: 2, label: '扫' },
    { value: 3, label: '换' }
  ]
  let getList = qspost('/Index/Service/getProjectServiceCate')
  if (getList.data.length > 0) {
    return getList.data
  } else {
    return arr
  }
}







/*
* 服务状态
* */
export const serviceState = [
  { value: 0, label: '全部' },
  { value: 1, label: '新申请' },
  { value: 2, label: '处理中' },
  { value: 3, label: '已完成' },
  { value: 4, label: '已取消' }
]

/*
* 服务满意度
* */
export const commentList = [
  { value: 0, label: '全部' },
  { value: 1, label: '非常满意   ' },
  { value: 2, label: '满意' },
  { value: 3, label: '一般' },
  { value: 4, label: '不满意' }
]



export const modular = [
  { value: 1, label: '首页统计', power: [3, 4, 5] },
  { value: 2, label: '党的建设', power: [5, 6] },
  { value: 3, label: '通知公告', power: [5, 6] },
  { value: 4, label: '综合改造', power: [3, 4, 5, 6] },
  { value: 5, label: '民意调查', power: [3, 4, 5, 6] },
  { value: 6, label: '独立民调', power: [5] },
  { value: 7, label: '物业管理', power: [3, 4, 5, 6] },
  { value: 8, label: '物业统计', power: [3, 4, 5] },
  { value: 9, label: '物业合同', power: [5, 6] },
  { value: 10, label: '物业情况', power: [3, 4, 5] },
  { value: 11, label: '居民数据', power: [5, 6] },
  { value: 12, label: '房屋数据', power: [5] },
  { value: 13, label: '共享文件', power: [5, 6] },
  { value: 14, label: '系统管理', power: [3, 4, 5, 6] },
  { value: 15, label: '账号管理', power: [3, 4, 5] },
  { value: 16, label: '社区管理', power: [3, 4] },
  { value: 17, label: '小区管理', power: [5] },
  { value: 18, label: '个人中心', power: [3, 4, 5, 6] },
]

export const monthList = [
  { value: 1, label: '1月', },
  { value: 2, label: '2月', },
  { value: 3, label: '3月', },
  { value: 4, label: '4月', },
  { value: 5, label: '5月', },
  { value: 6, label: '6月', },
  { value: 7, label: '7月', },
  { value: 8, label: '8月', },
  { value: 9, label: '9月', },
  { value: 10, label: '10月', },
  { value: 11, label: '11月', },
  { value: 12, label: '12月', },
]

/*
* 服务满意度
* */
export const wanchengList = [
  { value: 0, label: '全部状态' },
  { value: 1, label: '处理中' },
  { value: 2, label: '已完成' },
  { value: 3, label: '已取消' },
]

/*
* 服务满意度
* */
export const baoxiuList = [
  { value: 0, label: '全部报修类型' },
  { value: 1, label: '漏水' },
  { value: 2, label: '停电' },
  { value: 3, label: '电梯故障' },
  { value: 4, label: '门禁损坏' },
  { value: 5, label: '其他' }
]
/*
* 表彰投诉
* */
export const biaozhangList = [
  { value: 0, label: '全部' },
  { value: 1, label: '表彰' },
  { value: 2, label: '投诉' },
]

/*
* 积分排序
* */
export const sortsList = [  // 0默认排序 1积分正序 2积分倒序 3金暖宝正序 4金暖宝倒序 5银暖宝正序 6银暖宝倒序
  { value: 0, label: '默认排序' },
  { value: 1, label: '积分正序' },
  { value: 2, label: '积分倒序' },
  { value: 3, label: '金暖宝正序' },
  { value: 4, label: '金暖宝倒序' },
  { value: 5, label: '银暖宝正序' },
  { value: 6, label: '银暖宝倒序' },
]


/*
* 数据过滤全部
* */
export const optionList = (state, arr) => {
  if (state) {
    return arr
  } else {
    return arr.slice(1)
  }
}

/*
* value转换为label
* */
export const filesCN = (val, arr) => {
  if (val) {
    let _str = arr.filter(item => val === item.value)
    return _str[0].label
  } else {
    return ''
  }

}

/*
* value转换为label
* */
export const filesCNOher = (val, arr) => {
  if (val) {
    let _str = arr.filter(item => val === item.id)
    return _str[0].name
  } else {
    return ''
  }

}



/*
* 时间转换
* */
export const zhDate = (date, type) => {
  let now = new Date(date)
  let year = now.getFullYear()
  let month = now.getMonth() + 1
  let day = now.getDate()
  let hour = now.getHours()
  let minute = now.getMinutes()
  let second = now.getSeconds()
  if (type === 1) {
    return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute)
  } else if (type === 2) {
    return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
  } else if (type === 3) {
    return getzf(hour) + ":" + getzf(minute)
  } else if (type === 4) {
    return year
  } else if (type === 5) {
    return month
  } else if (type === 8) {
    return year + "年" + getzf(month) + "月" + getzf(day) + "日 " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
  } else if (type === 9) {
    return year + "" + getzf(month) + "" + getzf(day)
  } else {
    return year + "-" + getzf(month) + "-" + getzf(day)
  }
}

function getzf(num) {
  if (parseInt(num) < 10) {
    num = '0' + num
  }
  return num
}


export const zhRmb = (num) => {
  if (Number(num) > 10000) {
    return (Number(num) / 10000).toFixed(2) + '万元'
  } else {
    return num + '元'
  }
}

//以下是时间戳函数
export const getDate = () => {
  var myDate = new Date();
  //获取当前年
  var year = myDate.getFullYear();
  //获取当前月
  var month = myDate.getMonth() + 1;
  //获取当前日
  var date = myDate.getDate();
  var h = myDate.getHours(); //获取当前小时数(0-23)
  var m = myDate.getMinutes(); //获取当前分钟数(0-59)
  var s = myDate.getSeconds();
  //获取当前时间
  var now = year + conver(month) + conver(date) + conver(h) + conver(m) + conver(s) + "_";
  return now;
}

export const conver = (s) => {
  return s < 10 ? '0' + s : s;
}


export const getQnyToken = () => {
  var token;
  var policy = {};
  var bucketName = 'yhyjy';//你的七牛桶名称
  var AK = '_MhT6BWLiDGy2755HTwoxzNH747ecCtlqldVq3p3'; //你的七牛AK
  var SK = '15juIkGIozY13PvocO4o5lckBFb-OzqFrSVAAM7z';//你的七牛SK
  var deadline = Math.round(new Date().getTime() / 1000) + 3600;
  policy.scope = bucketName;
  policy.deadline = deadline;
  token = genUpToken(AK, SK, policy);
  return token
}

export const getQNFileName = (name) => {
  let file_name = name.split('/')
  return `${file_name[file_name.length - 1]}`
}
export const getQNFileKey = (name) => {
  let file_name = name.split('/')
  return `sjf/uploads/images/${zhDate(new Date().getTime(), 9)}/${file_name[file_name.length - 1]}`
}

export const GetExtensionFileName = (pathfilename) => {
  var reg = /(\\+)/g;
  var pfn = pathfilename.replace(reg, "#");
  var arrpfn = pfn.split("#");
  var fn = arrpfn[arrpfn.length - 1];
  var arrfn = fn.split(".");
  return arrfn[arrfn.length - 1];
}
/*
* 设备类型
* 1 水浸传感器 2烟雾传感器 3人体跌倒传感器 4声光报警器',
* */
export const devTypeList = [
  { value: 1, label: '水浸传感器' },
  { value: 2, label: '烟雾传感器' },
  { value: 3, label: '人体跌倒传感器' },
  { value: 4, label: '声光报警器' },
  { value: 5, label: '充电过载报警器' },
]
/*
* 居民属性
* */
export const jvminShuxingList = [
  { value: 1, label: '特困' },
  { value: 2, label: '高龄' },
  { value: 3, label: '失独' },
  { value: 4, label: '独居' },
  { value: 5, label: '其他' },
]

/*
* 发送短信
* */
export const smsObjectList = [
  { value: 1, label: '服务对象' },
  { value: 2, label: '监护人' },
  { value: 3, label: '双方发送' },
]


export const formatPhone = (val) => {
  return val.replace(/(\d{3})\d{6}(\d{2})/, '$1****$2')
}
//姓名替换**
export const formatName = (val) => {
  return val.replace(/(.{1})(.{1,})/, '$1**')
}

export const downloadFile = (data, fileName) => {
  let url = window.URL.createObjectURL(new Blob([data]));
  let link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
}


export const FILE_ACCEPT = {
  IMAGE: 'image/*',//图片
  VIDEO: 'video/*,audio/*',//音视频
  WORD: 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-works',//word
  EXCEL: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-works',//excel
  EXPM_WORD: '.docx',//word
  PPT: 'application/vnd.ms-powerpoint,application/vnd.ms-works',//ppt
  PDF: 'application/pdf',//pdf
  ZIP: '.zip,application/zip,application/x-compressed',//zip
  RAR: '.rar',//rar
  ALL: '',//rar
}